export default __webpack_public_path__ + "static/media/P20012.93094193.png";